import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_CATEGORY } from "../category.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateCategoryInput } from "../../../__generated__/globalTypes";
import {
  CreateCategoryMutation,
  CreateCategoryMutationVariables,
} from "../../../__generated__/CreateCategoryMutation";

interface IProps {
  defaultValues: DeepPartial<CreateCategoryInput>;
  onCompleted: () => any;
}

export const useCreateCategory = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateCategoryInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateCategoryMutation,
    CreateCategoryMutationVariables
  >(CREATE_CATEGORY, {
    refetchQueries: ["CategoriesQuery"],
    update(cache) {
      evictFields(cache, ["category", "categories"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createCategory?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createCategory?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
